import React from 'react';
import './MissionSection.css';

const MissionSection = () => {
  return (
    <section className="mission-section">
      <div className="container">
        <div className="mission-grid">
          <div className="mission-content">
            <p>
              flowdo is a cloud-based business management platform developed and managed by Innate Technologies L.L.C-FZ, headquartered in Dubai,
              UAE with a branch office in Kochi, Kerala, India. We are driven by the vision to simplify how small and medium enterprises (SMEs) manage
              their day-to-day operations by offering an integrated platform that brings multiple business functionalities together in one place.
            </p>
            <p>
              Our journey began with the launch of the Task Management module, enabling individuals and companies to organize, assign, and track tasks
              with ease. Unlike conventional tools that require businesses to juggle between spreadsheets, emails, or multiple software subscriptions, flowdo
              provides a streamlined, cost-effective, and secure solution that helps users stay productive and efficient. With features such as task
              assignment, reminders, and real-time collaboration, flowdo ensures that no task goes unnoticed or delayed.
            </p>
            <p>
              Looking ahead, flowdo is designed as a growing ecosystem. Our mission is to continuously expand the platform with additional modules such
              as HR, Payroll, Inventory, Accounts, and many more — allowing businesses to select only the functionalities they need without being forced
              into unnecessary subscriptions. By focusing on reliability, simplicity, and scalability, we aim to become the go-to digital partner for SMEs
              seeking smarter ways to run their operations in today’s fast-paced business environment.
            </p>
          </div>
          <div className="mission-and-vision">
            <div className="mission-content">
              <h6>Our Vision</h6>
              <p>
                “To become the most trusted and comprehensive cloud-based platform for companies, empowering businesses to manage their daily
                operations seamlessly, cost-effectively, and reliably from a single, unified system.”
              </p>
            </div>
            <div className="mission-content">
              <h6>Our Mission</h6>
              <p>
                “Our mission is to simplify business management for SMEs by providing an integrated, secure, and scalable platform that brings together
                essential functions of a company. We are committed to delivering user-friendly, customizable solutions that grow with businesses, enabling
                them to focus on what truly matters – innovation and growth.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection; 